import React, {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';
import {Spinner} from '../../Spinner';
import {APIClient} from '../../../utils/APIClient';
import {API_URL} from '../../../settings/local_settings';

function getUserLabel(user) {
    return user?.name || user?.full_name || user?.email || user?.username || '';
}

function getUserMeta(user) {
    return user?.email && user?.email !== getUserLabel(user) ? user.email : (user?.username || '');
}

export function ClientUsersPreviewBox({clientId}) {
    const {t} = useTranslation();
    const [users, setUsers] = useState(null);
    const [selectedUserIds, setSelectedUserIds] = useState(null);

    useEffect(() => {
        new APIClient(`${API_URL}client/${clientId}/dashbo-users`).call('GET').then(response => {
            if (response && response.status === 'OK') {
                setUsers(response.data.all_users || []);
                setSelectedUserIds((response.data.client_user_ids || []).map(id => id.toString()));
            } else {
                setUsers([]);
                setSelectedUserIds([]);
            }
        });
    }, [clientId]);

    const clientUsers = useMemo(() => {
        if (!users || !selectedUserIds) return null;
        return users.filter(user => selectedUserIds.includes(user.id.toString()));
    }, [users, selectedUserIds]);

    return (
        <div className="box client-users-preview-box">
            <div className="client-users-preview-header">
                <h3 className="client-users-preview-title">{t('control_central.users_title')}</h3>
                <Link className="cc-action-button -small" to={`/client/${clientId}/configuration`}>
                    {t('control_central.users_manage')} &rarr;
                </Link>
            </div>

            {clientUsers === null ? (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            ) : clientUsers.length > 0 ? (
                <div className="client-users-preview-list">
                    {clientUsers.map(user => (
                        <div key={user.id} className="client-users-preview-item">
                            <span className="client-users-preview-avatar">
                                <FaIcon iconName="user"/>
                            </span>
                            <span className="client-users-preview-copy">
                                <strong>{getUserLabel(user)}</strong>
                                {getUserMeta(user) && <small>{getUserMeta(user)}</small>}
                            </span>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="cc-empty-state">
                    <FaIcon iconName="users"/>
                    <p>{t('control_central.users_empty')}</p>
                    <Link className="btn -alt -small" to={`/client/${clientId}/configuration`}>
                        <FaIcon iconName="plus"/>
                        {t('control_central.users_manage')}
                    </Link>
                </div>
            )}
        </div>
    );
}
